import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { HostReceiptList_ManagementSalesReceiptsPage_Query } from "./query";

export const useHostReceiptList = (hotelID: string) => {
	const { data } = useCustomSuspenseQuery(HostReceiptList_ManagementSalesReceiptsPage_Query, {
		variables: { hotelID },
	});

	return {
		data,
	};
};
